export default __webpack_public_path__ + "static/media/logo_consulsteel.600be73b.svg";